export async function apexChartDownloadPng(chartRef, filename) {
  const chart = chartRef.current?.chart;
  if (!chart) return;
  const { imgURI } = await chart.dataURI({ scale: 2 });
  const a = document.createElement("a");
  a.href = imgURI;
  a.download = `${filename}.png`;
  a.click();
}
